export default {
  title: "Settings",
  languages: {
    en: "English",
    es: "Español",
  },
  mode: {
    light: "Light",
    dark: "Dark",
  },
}
